import { useTranslation } from 'next-i18next';
import React from 'react';
import { twMerge } from 'tailwind-merge';

import StandardTabs from './StandardTabs';
import { Content } from './ui/layout';
import Tabs, { Tab } from './ui/Tabs';

interface IProps {
  selectedStandard: string;
  setSelectedStandard: (val: string) => void;
  selectedPeriod: string;
  setSelectedPeriod: (val: string) => void;
  standardsTabsData: Tab[];
  reportingPeriodsTabsData: Tab[];
}

export const TAB_FILTER_HEIGHT = 80;

export const OrganizationTabsFilter: React.FC<IProps> = ({
  selectedStandard,
  setSelectedStandard,
  selectedPeriod,
  setSelectedPeriod,
  standardsTabsData,
  reportingPeriodsTabsData,
}) => {
  const { t } = useTranslation();
  return (
    <div
      className={twMerge('bg-white py-3 shadow-raised')}
      style={{ height: `${TAB_FILTER_HEIGHT}px` }}
    >
      <Content type='body' centered>
        <div className='flex items-center justify-center webM:!justify-between'>
          {standardsTabsData.length > 0 ? (
            <StandardTabs
              selectedStandard={selectedStandard}
              setSelectedStandard={setSelectedStandard}
              standardsTabsData={standardsTabsData}
              className='hidden w-auto webM:!block'
            />
          ) : (
            <div role='presentation' />
          )}
          <Tabs
            className='max-w-[320px]'
            label={t('reporting-year')}
            tabsList={reportingPeriodsTabsData}
            defaultValue={reportingPeriodsTabsData[0].value}
            value={selectedPeriod}
            onValueChange={(val) => {
              setSelectedPeriod(val);
            }}
          />
        </div>
      </Content>
    </div>
  );
};
